import { LmIconFilledMiscStar, LmIconOutlineMiscStar } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionEventsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineMiscStar {...rest} /> : <LmIconFilledMiscStar {...rest} />;

export default IconProfessionEventsCommon;
